/**
 * @generated SignedSource<<69ecfb346c431f484dbcc143d63d55d7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailAccordions_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanelItemModule_viewer" | "PdpRespDealerDetails_viewer" | "getPdpEstimateSimilarSold_viewer">;
  readonly " $fragmentType": "PdpRespDetailAccordions_viewer";
};
export type PdpRespDetailAccordions_viewer$key = {
  readonly " $data"?: PdpRespDetailAccordions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailAccordions_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isPdpSellerModuleTestVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailAccordions_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutItemPanelItemModule_viewer"
    },
    {
      "condition": "isPdpSellerModuleTestVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerDetails_viewer"
        }
      ]
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getPdpEstimateSimilarSold_viewer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "getHasEnoughSimilarSoldItems_viewer",
          "selections": [
            {
              "condition": "isEstimateSimilarSoldVariant",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": "similarSoldItemsResults",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 0
                    },
                    {
                      "kind": "Variable",
                      "name": "itemId",
                      "variableName": "itemId"
                    }
                  ],
                  "concreteType": "SimilarSoldItemsConnection",
                  "kind": "LinkedField",
                  "name": "similarSoldItems",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalResults",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ]
            }
          ],
          "args": null,
          "argumentDefinitions": [
            {
              "kind": "RootArgument",
              "name": "isEstimateSimilarSoldVariant"
            },
            {
              "kind": "RootArgument",
              "name": "itemId"
            }
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3786521a8e3d91edb34b9bcb28ffd650";

export default node;
